function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from 'react';

function SvgVpc(props) {
  const light = props.light || '#999';
  const dark = props.dark || '#000';
  return React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    "uc-svg": "www"
  }, props), React.createElement("path", {
    fill: "#526075",
    fillRule: "evenodd",
    d: "M18.208 8.43a6.69 6.69 0 00-6.663-6.003c-3.683 0-6.685 3.002-6.685 6.685 0 .228.023.478.046.705a6.395 6.395 0 003.479 11.756h6.662a6.958 6.958 0 006.958-6.958c0-2.683-1.546-5.025-3.797-6.185zm-1.956 8.754c-.66 0-1.228-.363-1.5-.91H9.702c-.295.547-.864.91-1.5.91a1.718 1.718 0 01-1.706-1.705c0-.91.728-1.66 1.615-1.705l2.069-4.275a1.711 1.711 0 01-.341-1c0-.933.773-1.706 1.705-1.706.933 0 1.706.773 1.706 1.705 0 .91-.728 1.66-1.638 1.706l-2.046 4.275c.045.068.114.159.16.227h5.047c.296-.546.864-.91 1.5-.91.933 0 1.706.773 1.706 1.706a1.718 1.718 0 01-1.728 1.682z"
  }));
}

SvgVpc.clsName = 'icon-www__vpc';
SvgVpc.remarkName = 'unknown';
export default SvgVpc;


//////////////////
// WEBPACK FOOTER
// ./node_modules/@ucloud/ucloud-icons/dist/www/svgr/Vpc.js
// module id = 2537
// module chunks = 17 18